function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#1D998C",
  stroke: "#F3F3F3"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2.5,
  d: "M50.094 35.541l-5.529-5.551-14.763 14.711-8.662-8.2-5.383 5.688 14.188 13.429z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.485 1v4.445H1.352V71H64.43V5.445H48.293V1h-5.539v4.445H23.021V1h-5.536zm41.404 64.461H6.888v-39.31h51.998l.003 39.31zM42.757 10.984v3.336h5.538v-3.336H58.89v9.63H6.888v-9.63h10.594v3.336h5.539v-3.336h19.736z"
}));

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 72,
    viewBox: "0 0 65 72"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/calendar.937c4c01.svg";
export { SvgCalendar as ReactComponent };